<template>
	<div class="head2_wrap">
		<div class="head2_box1 flex3">
			<img v-if="meauShow" @click="handMeau" class="hb_img1" src="@/images/phone/heng3.png" />
			<div v-else class="back_box flex3" @click="backOne">
				<img src="@/images/productCenter/left1.png">
				<span>返回</span>
			</div>
			<div class="hb_text">{{pageTitle}}</div>
			<div class="hb_img2 flex3">
				<img v-show="searchShow" @click="handSearch" src="@/images/phone/zoom.png" />
                <!-- <span @click="languageChange">EN</span> -->
			</div>
		</div>
		<transition name="fade">
			<div v-show="ltshow" class="head2_box2 animate__animated" :class="ltshow?'animate__slideInLeft':'animate__slideOutLeft'">
				<div class="hd2_item" @click="toPage(item)" v-for="(item,index) in headList" :key="index">{{ item.title}}</div>
			</div>
		</transition>
		<transition name="fade">
			<div v-show="searchShow" class="head2_box33 animate__animated" :class="scshow?'animate__fadeInDown':'animate__fadeOutUp'" :style="{top:hdtop}">
				<div class="sc_box flex1">
					<input type="text" v-model="newsKey" placeholder="请输入关键字">
					<button @click="toSearch"></button>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
	name: 'Header2',
	props: {
		searchShow: {
			type: Boolean,
			default: false,
		},
		meauShow: {
			type: Boolean,
			default: true,
		},
		pageTitle: {
			type: String,
			default: '剑南春官方网站'
		}
	},
	data() {
		return {
			ltshow: false,
			scshow: false,
            newsKey:'',
            hdtop:0
		};
	},
	computed: {
		...mapState(["language","headList"]),
	},
	created() {
        setTimeout(() => {
            this.hdtop = '1.23rem';
        }, 400);
    },
	methods: {
        languageChange(){
            this.$store.state.language = 2;
            this.$router.push("/en/home");
            this.$store.state.curtAct = null;
            this.$store.state.curtAct2 = null;
            this.$store.state.headAct = 0;
            this.$store.state.enAct1 = 0;
            localStorage.setItem('yuyan', 2);
        },
		handMeau() {
			this.ltshow = !this.ltshow;
			if (this.ltshow) {
				this.scshow = false;
			}
		},
		handSearch() {
			if (!this.ltshow) {
				this.scshow = !this.scshow;
			}
		},
		toPage(item) {
			this.ltshow = false;
			this.$router.push(item.name);
		},
		backOne() {
			window.history.back();
		},
		toSearch() {
			if (!this.newsKey.trim()) {
				this.$message({
					message: '请输入搜索内容',
					type: 'error',
					offset: 100,
					duration: 3000
				});
			} else {
				this.$router.push("/newssearch?newsKey=" + this.newsKey);
				this.seshow = false;
			}
		}
	},
};
</script>

<style lang="scss">
.head2_wrap {
	.head2_box1 {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		z-index: 1120;
		background-color: #d50000;
		height: 1.23rem;
		padding: 0 0.5rem;
		.hb_img1 {
			width: 0.55rem;
		}
		.back_box {
			img {
				width: 0.28rem;
			}
			span {
				color: #fff;
				font-size: 15px;
				margin-left: 0.3rem;
			}
		}
		.hb_text {
			flex: 1;
			text-align: center;
			color: #fff;
			color: #fff;
			font-size: 17px;
			font-weight: 700;
			text-align: center;
		}
		.hb_img2 {
			img {
				width: 0.55rem;
			}
            span{
                font-size: 0.4rem;
                color: #fff;
                margin-left: 0.3rem;
                margin-top: 0.06rem;
            }
		}
	}
	.head2_box2 {
		position: fixed;
		top: 1.23rem;
		bottom: 0;
		left: 0;
		z-index: 1119;
		background-image: url("../images/phone/ltbg.png");
		background-repeat: repeat;
		box-sizing: border-box;
		padding: 0 0.5rem;
		animation-duration: 0.3s;
		box-shadow: 5px 0 5px 0 rgba(0, 0, 0, 0.1);
		.hd2_item {
			display: block;
			text-align: left;
			color: #787878;
			font-size: 17px;
			font-weight: 700;
			padding: 0.45rem;
		}
	}
	.head2_box33 {
		position: fixed;
		// top:2.42rem;
		// top: 0;
		padding: 0.18rem;
		left: 0;
		right: 0;
		z-index: 9;
		animation-duration: 0.3s;
		.sc_box {
			input {
				background-color: #fff;
				height: 1rem;
				border-top-left-radius: 3px;
				border-bottom-left-radius: 3px;
				color: #333;
				font-size: 14px;
				flex: 1;
				padding: 0 10px;
				outline: none;
				border: none;
				box-sizing: border-box;
			}
			button {
				width: 1.333rem;
				background-image: url("../images/zoom.png");
				background-repeat: no-repeat;
				background-position: 50%;
				background-size: 20px auto;
				height: 1rem;
				background-color: #d50000;
				border-top-right-radius: 3px;
				border-bottom-right-radius: 3px;
				outline: none;
				border: none;
			}
		}
	}
}
</style>